import apolloClient from '../../utils/apollo-client';
import { updateApplication as mutation } from '../graphql/application';

export default async function (payload) {
  const response = await apolloClient().then((client) =>
    client.mutate({
      mutation,
      variables: {
        payload
      }
    })
  );
  return response.data.updateActiveApplication;
}
